<template>
  <div
    class="overflow-x-auto rounded-lg shadow-sm border border-gray-200 min-h-[300px] animate-pulse"
  >
    <div
      class="hidden md:grid lg:grid-cols-12 md:grid-cols-6 gap-1 w-full items-center px-4 py-2"
      style="background: var(--Neutral-LightGray-5, #fafafa)"
    >
      <div class="lg:col-span-3 md:col-span-4 flex">
        <div class="h-4 w-16 bg-slate-200 rounded ml-14"></div>
      </div>
      <div class="lg:col-span-3 hidden lg:block">
        <div class="h-4 w-14 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-2 hidden lg:block">
        <div class="h-4 w-20 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-2 hidden lg:block">
        <div class="h-4 w-20 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-2 md:col-span-2 flex justify-center">
        <div class="h-4 w-14 bg-slate-200 rounded"></div>
      </div>
    </div>

    <div
      v-for="n in 8"
      :key="n"
      class="grid lg:grid-cols-12 md:grid-cols-6 gap-1 w-full items-center px-4 py-3 border-b border-gray-100"
    >
      <div class="hidden md:flex md:col-span-4 lg:col-span-3 items-center gap-3">
        <div class="h-10 w-10 rounded-full bg-slate-200 shrink-0"></div>
        <div class="h-4 w-3/4 bg-slate-200 rounded"></div>
      </div>

      <div class="hidden lg:block lg:col-span-3">
        <div class="h-4 w-11/12 bg-slate-200 rounded"></div>
      </div>

      <div class="hidden lg:block lg:col-span-2">
        <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
      </div>

      <div class="hidden lg:block lg:col-span-2">
        <div class="flex gap-2">
          <div class="h-6 w-16 bg-slate-200 rounded-full"></div>
          <div class="h-6 w-10 bg-slate-200 rounded-full"></div>
        </div>
      </div>

      <div class="hidden md:block md:col-span-2 lg:col-span-2">
        <div class="flex items-center justify-around">
          <div class="h-5 w-9 bg-slate-200 rounded-full"></div>
          <div class="h-7 w-7 bg-slate-200 rounded"></div>
          <div class="h-7 w-7 bg-slate-200 rounded"></div>
          <div class="h-7 w-7 bg-slate-200 rounded"></div>
        </div>
      </div>

      <div class="flex gap-3 md:hidden col-span-6 px-3">
        <div class="h-10 w-10 rounded-full bg-slate-200 shrink-0"></div>
        <div class="flex flex-col gap-2 flex-1">
          <div class="h-4 w-3/4 bg-slate-200 rounded"></div>
          <div class="h-3 w-1/2 bg-slate-200 rounded"></div>
          <div class="flex gap-1 pt-1">
            <div class="h-5 w-9 bg-slate-200 rounded-full"></div>
            <div class="h-6 w-6 bg-slate-200 rounded"></div>
            <div class="h-6 w-6 bg-slate-200 rounded"></div>
            <div class="h-6 w-6 bg-slate-200 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
